export const learningStyles = [
  { id: 'visual', value: 'visual', label: 'Visual' },
  { id: 'auditory', value: 'auditory', label: 'Auditory' },
  { id: 'kinesthetic', value: 'kinesthetic', label: 'Kinesthetic' },
  { id: 'reading_writing', value: 'reading_writing', label: 'Reading/Writing' },
]; 